import React, {Component} from 'react';
import { connect } from 'dva';
import { Button } from 'antd';
import BaseComponent from '../../../components/BaseComponent';

class SortPrice extends BaseComponent {
  constructor(props) {
    super(props);
    this.handleSort = this.handleSort.bind(this);
  }

  handleSort(e){
    const {dispatch} = this.props;

    dispatch({
      type: 'travel/sortPrice'
    });
  }

  render() {
    return(
      <div>
        <Button style={{ width: '100%' }} onClick={this.handleSort}>値段で並び替え</Button>
      </div>
    )
  }
}

export default connect(({ travel }) => ({
  travel
}))(SortPrice);



// WEBPACK FOOTER //
// ./src/pages/travel/components/SortPrice.js